import React from 'react';


const PrivacyPolicy = () => {
    return (
        <div className="p-6 max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
            <p className="mb-4">Effective Date: May 1, 2025</p>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">1. Overview</h2>
                <p>
                    This Privacy Policy explains how DunderDebunk ("we", "our", or "us") collects, uses, and protects your data when you use our browser extension, web application, or any of our services that leverage AI for misinformation detection. We are committed to protecting your privacy and complying with the Chrome Web Store User Data Policy and all applicable privacy laws.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">2. Data We Collect</h2>
                <p>We collect only the data necessary to provide and improve our service. This may include:</p>
                <ul className="list-disc pl-6 mt-2">
                    <li><strong>Content for Analysis:</strong> Text content from webpages you explicitly choose to analyze using the extension.</li>
                    <li><strong>Extension Usage Data:</strong> Interaction events such as clicks on buttons or toggles, time of use, and sentiment rating submissions.</li>
                    <li><strong>Diagnostic Data:</strong> Basic anonymized logs to help identify errors and improve functionality (e.g., error messages, browser type).</li>
                    <li><strong>No Personally Identifiable Information (PII):</strong> We do not collect your name, email, location, or any personal identifiers.</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">3. How We Use Your Data</h2>
                <ul className="list-disc pl-6 mt-2">
                    <li>To process selected content through our AI models to identify potential misinformation.</li>
                    <li>To enhance the accuracy and performance of our misinformation detection tools.</li>
                    <li>To provide feedback and visual cues to help users critically evaluate online content.</li>
                    <li>To detect and fix bugs, improve security, and optimize user experience.</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">4. Data Sharing and Disclosure</h2>
                <p>
                    We do <strong>not</strong> sell, rent, or share your data with third parties for advertising or marketing. We may share anonymized or aggregated data:
                </p>
                <ul className="list-disc pl-6 mt-2">
                    <li>With service providers strictly for hosting, analytics, or AI model support (e.g., OpenAI or similar providers), under confidentiality agreements.</li>
                    <li>To comply with legal obligations, such as responding to lawful requests from law enforcement.</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">5. Data Retention</h2>
                <p>
                    Content analyzed via the extension is processed in real-time and is <strong>not stored permanently</strong>. Diagnostic data is anonymized and stored only as long as needed for troubleshooting and performance improvements, typically no longer than 90 days.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">6. Security</h2>
                <p>
                    We implement industry-standard security measures to safeguard your data, including HTTPS encryption, secure APIs, and restricted access protocols. While we strive to protect your data, no system is 100% secure, and we cannot guarantee absolute security.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">7. User Control & Consent</h2>
                <p>
                    You control what content is analyzed by our extension. We do not access content unless you initiate analysis. You may uninstall the extension at any time to stop data collection. We do not store personal user preferences or identifiers unless explicitly provided.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">8. Children’s Privacy</h2>
                <p>
                    Our services are not intended for children under 13. We do not knowingly collect personal information from children. If we discover such information was collected unintentionally, we will delete it promptly.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">9. Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Updates will be posted here with a new effective date. If we make material changes, we will provide additional notice as required by law.
                </p>
            </section>

            <section>
                <h2 className="text-xl font-semibold mb-2">10. Contact Us</h2>
                <p>
                    For questions, concerns, or data access requests, please contact us at: <br />
                    <a href="mailto:privacy@dunderdebunk.com" className="text-blue-600">privacy@dunderdebunk.com</a>
                </p>
            </section>
        </div>
    );
};

export default PrivacyPolicy;
